import { useEffect, useState } from 'react';

import Bugsnag from '@bugsnag/browser';

import {
  parsePdfHtmlContent,
  ParsePdfHtmlContentResult,
} from './content-parser';

export const useElementWidth = (): [
  (node: HTMLDivElement | null) => void,
  number | undefined,
] => {
  const [node, setNode] = useState<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>();

  useEffect(() => {
    if (!node) return;

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry) {
        setWidth(entry.contentRect.width);
      }
    });

    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [setNode, width];
};

export const useParsePdfHtmlContent = (
  htmlContent?: string,
): ParsePdfHtmlContentResult | undefined => {
  const result = htmlContent ? parsePdfHtmlContent(htmlContent) : undefined;

  const parseError = result?.[1];

  useEffect(() => {
    if (parseError) {
      Bugsnag.notify(parseError);
      console.error('Error parsing PDF HTML content:', parseError);
    }
  }, [parseError]);

  return result;
};
